import(/* webpackMode: "eager", webpackExports: ["OrderProvider"] */ "/vercel/path0/src/components/order/OrderContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/Order.tsx");
